import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const List = styled.ul`
  border-top: 1px solid ${({ theme }) => theme.defaultColors.lightGrey};
  border-bottom: 1px solid ${({ theme }) => theme.defaultColors.lightGrey};
  list-style: 'none';
  display: flex;
  padding: 20px 0;

  ${media.md`
    margin-left: 60px;
  `}
`;

export const ListItem = styled.li`
  display: flex;
  flex-direction: column;
  margin-right: 25px;

  ${media.md`
    margin-right: 140px;
  `}

  h4 {
    margin-bottom: 5px;
    font-weight: 600;
  }

  span {
    white-space: nowrap;
  }
`;
